import { Injectable } from '@angular/core';
import { TableDataApiParams } from '@services/practices.service';
import { CashMovementsTableModel } from '@/models/tables/cash-movements-table.model';
import { CashMovementsService } from '@services/cash-movements.service';
import { DataSourceBaseNew } from '@components/new-table/data-source-base-new.dataSource';

@Injectable({
  providedIn: 'root',
})
export class CashMovementsDataSource extends DataSourceBaseNew<CashMovementsTableModel> {
  constructor(private cashMovementsService: CashMovementsService) {
    super();
  }

  loadData(params?: TableDataApiParams): void {
    console.log('params', params);

    this._isLoading$.next(true);
    this.cashMovementsService
      .getTableData<CashMovementsTableModel>('cashMovements', params)
      .subscribe((data) => {
        this.elements$.next(data.content);
        this._totalElements$.next(data.totalElements);
        this._isLoading$.next(false);
      });
  }
}
